import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";
import { Icon } from "@formant/ui/component/common/Icon";

import { authStore } from "../../stores";
import { Button } from "../common/Button";
import { IItem } from "./IItem";
import * as styles from "./Item.scss";

export interface IItemProps {
    item: IItem;
    minimalUX?: boolean;
}

export class Item extends Component<IItemProps & ITestableComponentProps> {
    public render() {
        const { item, minimalUX } = this.props;
        const {
            inactive,
            icon,
            iconClassName,
            label,
            labelClassName,
            type,
            sublabel,
            toggled,
            checked,
            disabled,
            preChildren,
            children,
            highlight,
            invalid,
            onToggle,
            onEdit,
            onDelete,
            buttonClassName,
        } = item;

        return (
            <Button
                className={classnames(
                    styles.item,
                    styles.button,
                    toggled && styles.toggled,
                    checked && styles.checked,
                    disabled && styles.disabled,
                    onToggle && styles.toggleable,
                    onEdit && styles.editable,
                    inactive && styles.inactive,
                    invalid && styles.invalid,
                    buttonClassName,
                )}
                data-testid={this.props["data-testid"]}
                onClicked={this.onClicked}
            >
                {preChildren}
                {icon && (
                    <Icon
                        className={classnames(styles.icon, iconClassName)}
                        name={icon}
                    />
                )}
                {authStore.featureEnabled("onDemand") && highlight === true && (
                    <div className={classnames(styles["highlight-marker"])} />
                )}
                <div className={styles.text}>
                    {type && <div className={styles.type}>{type}</div>}
                    <div
                        className={classnames(styles.label, labelClassName)}
                        data-tooltip={label}
                    >
                        {label}
                    </div>
                    {sublabel && (
                        <div className={styles.sublabel}>{sublabel}</div>
                    )}
                </div>
                {onToggle && <Icon name="check" className={styles.check} />}
                {onEdit && (
                    <Icon
                        name="edit"
                        className={minimalUX ? styles.editRT : styles.edit}
                    />
                )}
                {onDelete && (
                    <Icon
                        name={minimalUX ? "minus" : "delete"}
                        className={minimalUX ? styles.deleteRT : styles.delete}
                        onClick={this.onDelete}
                    />
                )}
                {children}
            </Button>
        );
    }

    private onClicked = () => {
        const { item } = this.props;
        const { label, key, onToggle, onEdit } = item;
        if (onToggle) {
            onToggle(label, key);
        }

        if (onEdit) {
            onEdit(label, key);
        }
    };

    private onDelete = (event: MouseEvent<SVGElement>) => {
        const {
            item: { label, key, onDelete },
        } = this.props;
        event.stopPropagation();
        event.preventDefault();

        onDelete?.(label, key);
    };
}
